<template>
<svg viewBox="0 0 48 48" :fill="useCurrentColor ? 'currentColor' : '#000'" :class="[`${prefix}-icon`, `${prefix}-icon-video-on-demand`]" width="1em" height="1em" v-bind="$attrs"><path fill-rule="evenodd" clip-rule="evenodd" d="M14.536 2.707L22.827 11H24.9l8.292-8.292a1 1 0 011.32-.083l.095.083 1.414 1.414a1 1 0 01.083 1.32l-.083.095L30.556 11H45a2 2 0 011.995 1.85L47 13v31a2 2 0 01-1.85 1.995L45 46H3a2 2 0 01-1.995-1.85L1 44V13a2 2 0 011.85-1.995L3 11h14.171l-5.464-5.464a1 1 0 010-1.415l1.414-1.414a1 1 0 011.415 0zM43 15H5v27h38V15zm-23 6.29a1 1 0 01.524.148l10.092 6.21a1 1 0 010 1.704l-10.092 6.21A1 1 0 0119 34.71V22.29a1 1 0 011-1z"/></svg>
</template>
<script>

export default {
  name: 'IconVideoOnDemand',
  props: {
    prefix: {
        type: String,
        default: 'arco',
    },
    useCurrentColor: {
        type: Boolean,
        default: true,
    },
  },
};
</script>
